import form from './form.js';
import index from './index.js';
import { Router } from '@/legacy/Router';

Router.get('ai-model', index);
Router.get('ai-model/:any', form);
